import React, { useEffect } from 'react';
import styled from 'styled-components';

import { translate } from '@front/i18n';

import Text from '@front/web-ui/src/components/base-text/variants/text';
import LinkButton from '@front/web-ui/src/components/button/link-button';
import Title from '@front/web-ui/src/components/base-text/variants/title';

import { PRO_APP_DOWNLOAD_URL } from '../../utils/constants';
import usePlatform from '../../hooks/use-platform';
import { logAppDownloadClicked } from '../../utils/tracking';
import GradientBackgroundWrapper from '../../components/gradient-background-wrapper/gradient-background-wrapper';

const t = translate('screens.congratulations');

const StyledH1 = styled(Title.XXL)`
  margin: 170px 0 30px;
`;

const StyledText = styled(Text.LG)`
  margin: 0;
`;

const StyledButton = styled(LinkButton)`
  width: max-content;
  position: absolute;
  bottom: 100px;
  left: 50%;
  transform: translateX(-50%);
`;

const Congratulations = () => {
  const platform = usePlatform();

  useEffect(() => {
    // eslint-disable-next-line no-multi-assign
    document.body.scrollTop = document.documentElement.scrollTop = 0;
  }, []);

  const handleLinkClick = () => {
    logAppDownloadClicked(platform);
  };

  return (
    <GradientBackgroundWrapper testID='congratulations'>
      <StyledH1 centered>{t('.title')}</StyledH1>
      <StyledText htmlTag='p' centered>
        {t('.subtitle')}
      </StyledText>
      <StyledButton onClick={handleLinkClick} hasFullWidth={false} size='lg' href={PRO_APP_DOWNLOAD_URL} openInNewTab>
        {t('.cta')}
      </StyledButton>
    </GradientBackgroundWrapper>
  );
};

export default Congratulations;
